/**正在运行的事件 */
let eventIds: MyEvent[] = [];

interface MyEvent {
    eventId: number,
    eventName: string
}

/**添加监听事件 */
export function addTimer(eventName: string, event: Function, eventTimer: number) {
    removeTimer(eventName);
    let tempEventId = setInterval(event, eventTimer);
    let myEvent: MyEvent = {
        eventId: tempEventId,
        eventName: eventName
    };
    eventIds.push(myEvent);
}

/**删除事件 */
export function removeTimer(eventName: string) {
    let tempEvent: MyEvent = {
        eventId: 0,
        eventName: "",
    };
    if (eventIds && eventIds.length > 0) {
        eventIds.forEach((myEvent: MyEvent) => {
            if (myEvent.eventName == eventName) {
                tempEvent = myEvent;
                clearInterval(myEvent.eventId);

            }
        })
    }
    if (tempEvent.eventId != 0) {
        eventIds = eventIds.filter((tempMyEvent: MyEvent)=> tempMyEvent.eventId !== tempEvent.eventId);
    }
}